<template>
    <div id="logList" :class="$root.isMob() ? 'mob' : ''" v-loading="loading">
        <div v-if="loading" class="loadingAlert">
            <el-alert
                title="加载中"
                description="正在加载数据,这可能需要一些时间,请稍后..."
                type="warning"
                center
                show-icon
                :closable="false">
            </el-alert>
        </div>
        <h2><i class="el-icon-s-order icon"></i>
            {{ title }}
            <div class="reload" @click="getData(1)">
                <i class="el-icon-refresh-right icon"></i>刷新
            </div>
        </h2>
        <el-table :data="logsList" border style="width: 100%" v-if="!$root.isMob()">
            <el-table-column v-if="type == 1 || type == 2 || type == 6"  prop="name" :label="labelName" :resizable="false"></el-table-column>
            <el-table-column v-if="type == 6" prop="progress" label="完成进度" :resizable="false"></el-table-column>
            <el-table-column v-if="type == 6" prop="step" label="完成步骤" :resizable="false"></el-table-column>
            <el-table-column v-if="type == 6" prop="starttime" label="开始时间" :resizable="false"></el-table-column>
            <el-table-column v-if="type == 6" prop="endtime" label="结束时间" :resizable="false"></el-table-column>
            <el-table-column v-if="type == 6" prop="usetime" label="耗时" :resizable="false"></el-table-column>
            <el-table-column v-if="type == 6" prop="status" label="状态" :resizable="false">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status == 2" type="success">有效</el-tag>
                    <el-tag v-if="scope.row.status == 1" type="danger">无效</el-tag>
                </template>
            </el-table-column>
            <el-table-column v-if="type == 3" prop="exam_scores" label="总分数" :resizable="false">
                <template slot-scope="scope">
                    <div class="examScores">
                        {{ scope.row.exam_scores }}
                    </div>                    
                </template>
            </el-table-column>
            <el-table-column v-if="type == 3"  prop="createtime" label="开始时间" :resizable="false"></el-table-column>
            <el-table-column v-if="type == 3"  prop="endtime" label="结束时间" :resizable="false"></el-table-column>
            <el-table-column v-if="type == 3"  prop="usetime" label="耗时" :resizable="false"></el-table-column>            
            <el-table-column v-if="type == 1" prop="exam_result" label="考核成绩" :resizable="false">
                <template slot-scope="scope">
                    <div v-if="scope.row.exam_result == '未完成'" class="noExamResult">
                        {{ scope.row.exam_result }}
                    </div>
                    <div v-if="scope.row.exam_result != '未完成'" class="examResult">
                        {{ scope.row.exam_result }}
                    </div>                    
                </template>
            </el-table-column>
            <el-table-column v-if="type == 1" prop="starttime" label="开始时间" :resizable="false"></el-table-column>
            <el-table-column v-if="type == 1" prop="endtime" label="结束时间" :resizable="false"></el-table-column>
            <el-table-column v-if="type == 1" prop="usetime" label="耗时" :resizable="false"></el-table-column>
            <el-table-column v-if="type == 2" prop="createtime" label="时间" :resizable="false"></el-table-column>
            <el-table-column v-if="type == 2" prop="tests_nums" label="题数" :resizable="false"></el-table-column>
            <el-table-column v-if="type == 2" prop="exam_scores" label="总分数" :resizable="false">
                <template slot-scope="scope">
                    <div class="examScores">
                        {{ scope.row.exam_scores }}
                    </div>                    
                </template>
            </el-table-column>
            <el-table-column v-if="(type == 2 || type == 1)" prop="status_text" label="状态" :resizable="false">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status == 2" type="success">{{ scope.row.status_text }}</el-tag>
                    <el-tag v-if="scope.row.status == 1" type="danger">{{ scope.row.status_text }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="180" :resizable="false">
                <template slot-scope="scope">
                    <div class="buttonGroup">
                        <el-button type="primary" @click="view(scope.row)">查看详情</el-button>
                    </div>                            
                </template>
            </el-table-column>
        </el-table>
        <div v-if="$root.isMob()" class="mobTable">
            <div class="item" v-for="item in logsList" :key="item.id">
                <div class="info" v-if="type == 1 || type == 2 || type == 6"><span class="title">名称:</span>{{ item.name }}</div>
                <div class="info" v-if="type == 1"><span class="title">考核成绩:</span><span :class="item.exam_result=='未完成'?'':'result'">{{ item.exam_result }}</span></div>
                <div class="info" v-if="type == 2 || type == 3"><span class="title">得分:</span><span class="result">{{ item.exam_scores }}</span></div>
                <div class="info" v-if="type == 1 || type == 3 || type == 6"><span class="title">耗时:</span>{{ item.usetime }}</div>
                <div class="info" v-if="type == 2 || type == 1 || type == 6">
                    <span class="title">状态:</span>
                    <el-tag v-if="item.status == 2" type="success">{{ type == 6 ? '有效' : item.status_text }}</el-tag>
                    <el-tag v-if="item.status == 1" type="danger">{{ type == 6 ? '无效' : item.status_text }}</el-tag>
                </div>
                <div class="info" v-if="type == 2"><span class="title">题数:</span><span>{{ item.tests_nums }}</span></div>
                <div class="info" v-if="type == 2"><span class="title">时间:</span>{{ item.createtime }}</div>
                <div class="info" v-if="type == 6"><span class="title">完成进度:</span>{{ item.progress }}</div>
                <div class="info" v-if="type == 6"><span class="title">完成步骤:</span>{{ item.step }}</div>
                <div class="info" v-if="type == 1 || type == 6"><span class="title">开始时间:</span>{{ item.starttime }}</div>
                <div class="info" v-if="type == 1 || type == 6"><span class="title">结束时间:</span>{{ item.endtime }}</div>
                <div class="info" v-if="type == 3"><span class="title">开始时间:</span>{{ item.createtime }}</div>
                <div class="info" v-if="type == 3"><span class="title">结束时间:</span>{{ item.endtime }}</div>
                <div class="buttonGroup">
                    <el-button type="primary" @click="view(item)">查看详情</el-button>
                </div>
            </div>
        </div>
        <div class="pageList">
            <el-pagination :pager-count="$root.isMob ? 5 : 7" background layout="prev, pager, next" :current-page="currentPage" :page-count="pageNum" @current-change="changePage"></el-pagination>
        </div>        

        <el-dialog :title=detailTitle :visible.sync="isShowDetail" :width="$root.isMob()?'90%':'80%'" @open="this.$root.resetDialog">
            <div id="unityLogDetail" :class="$root.isMob()?'detailMob':''" v-loading="detailLoading" v-if="type == 1">

                <div class="unityDataResult">
                    <div class="ruleBox">
                        <div class="title">
                            成绩评定规则:
                        </div>                        
                        <div v-html="assessment"></div>
                    </div>  
                    <div class="examResultBox">
                        <div class="title">
                            最终考核成绩:
                        </div>
                        <span>{{ unityDetailData.exam_result }}</span> 
                    </div>           
                    <div class="progressBox" v-if="!$root.isMob()">
                        <div class="title">
                            得分情况:
                        </div>
                        <div class="progress" :style="`background: linear-gradient(to right, #5e8743 ${(examineScores / examineDimensionMax * 100)}%, #FFFFFF 0%)`">
                            <div class="line" style="left: 0;background-color: transparent;">
                                <div class="text">
                                    0分
                                </div>
                            </div>
                            <div class="line" v-for="i in examineDimension" :key="'line_'+i.sign" :style="i.score != examineDimensionMax ? `left:${i.score / examineDimensionMax * 100}%` : `left:calc(${i.score/examineDimensionMax * 100}% - 1px);background-color:transparent`">
                                <div class="text">
                                    {{ i.score }}分
                                </div>
                            </div>
                            <div class="result" v-for="i in examineDimension" :key="'result_'+i.score" :style="'width:'+i.width+'%'">                                
                                <svg xmlns="http://www.w3.org/2000/svg" class="svgText">
                                    <text x="50%" y="70%" font-size="20" fill="white" stroke="#5e8743" stroke-width="1">
                                        {{ i.sign }}
                                    </text>
                                </svg>
                            </div>
                            <div class="score" :style="`left:calc(${((examineScores / examineDimensionMax * 100))}% - ${(((examineScores.toString().length - 3) * 0.35) + 1.5)}rem)`">
                                {{examineScores}}分
                                <i class="el-icon-caret-bottom icon"></i>
                            </div>
                        </div>
                    </div>     
                    <div class="stepInfo" v-if="mainSteps.length > 0">
                        <div class="title">关键步骤操作情况:</div>
                        <div class="mainSteps" :style="$root.isMob()?'height:'+mainSteps.length*60+'px':''">
                            <el-steps :direction="$root.isMob()?'vertical':''" :simple="$root.isMob()?false:true" style="margin-top: 20px">
                                <el-step v-for="item in mainSteps" :key="item.name" :title="item.name" :status="item.status"></el-step>
                            </el-steps>
                        </div>
                    </div>
                </div>
                <div class="mainStep" v-for="(mainItem,key) in unityDetailData" :key="mainItem.name">
                    <div class="mainTitle">
                        <h2>{{ key+1 }}.{{ mainItem.name }}&nbsp;({{ key+1+"/"+unityDetailData.length }})</h2>
                        <h3 v-if="mainItem.description != ''">{{ mainItem.description }}</h3>
                    </div>                    
                    <div class="item" v-for="(item,itemKey) in mainItem.child" :key="itemKey+'_'+item.name">
                        <div class="row">
                            <div class="title">
                                <div class="left">
                                    <h3 v-if="!$root.isMob()">步骤({{ itemKey+1 + "/" + mainItem.child.length }}):</h3>
                                    <h4 v-if="$root.isMob()">步骤({{ itemKey+1 + "/" + mainItem.child.length }}):</h4>
                                </div>
                                <h3 v-if="item.yn_right == 1 && !$root.isMob()" class="wrong">{{ item.name }}</h3>
                                <h3 v-if="item.yn_right == 2 && !$root.isMob()" class="right2">{{ item.name }}</h3>
                                <h3 v-if="item.yn_right == 3 && !$root.isMob()" class="right">{{ item.name }}</h3>
                                <h3 v-if="item.yn_right == 4 && !$root.isMob()" class="skip">{{ item.name }}</h3>

                                <h4 v-if="item.yn_right == 1 && $root.isMob()" class="wrong">{{ item.name }}</h4>
                                <h4 v-if="item.yn_right == 2 && $root.isMob()" class="right2">{{ item.name }}</h4>
                                <h4 v-if="item.yn_right == 3 && $root.isMob()" class="right">{{ item.name }}</h4>
                                <h4 v-if="item.yn_right == 4 && $root.isMob()" class="skip">{{ item.name }}</h4>
                            </div>
                            <div class="isRight" v-if="!$root.isMob()">
                                <div class="text" v-if="item.yn_right == 1">
                                    <el-tag type="danger">错误</el-tag>
                                </div>
                                <div class="text" v-if="item.yn_right == 2">
                                    <el-tag type="warning">部分得分</el-tag>
                                </div>
                                <div class="text" v-if="item.yn_right == 3">
                                    <el-tag type="success">正确</el-tag>
                                </div>
                                <div class="text" v-if="item.yn_right == 4">
                                    <el-tag type="info">未操作</el-tag>
                                </div>
                                <div class="text" v-if="item.yn_main == 2">
                                    <el-tag type="danger" effect="dark">关键步骤</el-tag>
                                </div>
                            </div>
                        </div>

                        <div class="isRight" v-if="$root.isMob()">
                            <div class="text" v-if="item.yn_right == 1">
                                <h4>结果:</h4><el-tag type="danger">错误</el-tag>
                            </div>
                            <div class="text" v-if="item.yn_right == 2">
                                <h4>结果:</h4><el-tag type="warning">部分得分</el-tag>
                            </div>
                            <div class="text" v-if="item.yn_right == 3">
                                <h4>结果:</h4><el-tag type="success">正确</el-tag>
                            </div>
                            <div class="text" v-if="item.yn_right == 4">
                                <h4>结果:</h4><el-tag type="info">未操作</el-tag>
                            </div>
                            <div class="text" v-if="item.yn_main == 2">
                                <el-tag type="danger" effect="dark">关键步骤</el-tag>
                            </div>
                        </div>

                        <div class="row score">
                            <div class="left">
                                <h4>得分:</h4>
                            </div>
                            <div class="text">
                                {{ item.score }}<span>/{{ item.step_score }}</span>
                            </div>                        
                        </div>

                        <div class="row loseReason" v-if="item.lose_reason != ''">
                            <div class="left">
                                <h4>失分原因:</h4>
                            </div>
                            <div class="text">
                                {{ item.lose_reason }}
                            </div>
                        </div>
                        
                        <div class="row description">
                            <div class="left">
                                <h4>步骤说明:</h4>
                            </div>
                            <div class="text">
                                {{ item.step_description }}
                            </div>
                        </div>     
                    </div>
                </div>
            </div>

            <div id="unityLogDetail" :class="$root.isMob()?'detailMob':''" v-loading="detailLoading" v-if="type == 6">

                <div class="unityDataResult">
                    <div class="ruleBox">
                        <div class="title">
                            练习评定规则:
                        </div>                        
                        <div>根据完成步骤计算进度</div>
                    </div>  
                    <div class="examResultBox">
                        <div class="title">完成进度:</div>
                        <span>{{ practiceFinishedSteps }}/{{ practiceTotalSteps }}（{{ practiceProgressPercent }}%）</span> 
                    </div>           
                    <div class="progressBox" v-if="!$root.isMob()">
                        <div class="title">
                            完成情况:
                        </div>
                        <div class="progress" :style="`background: linear-gradient(to right, #5e8743 ${practiceProgressPercent}%, #FFFFFF 0%)`">
                            <div class="line" style="left: 0;background-color: transparent;">
                                <div class="text">
                                    0%
                                </div>
                            </div>
                            <div class="line" style="left: 100%;background-color: transparent;">
                                <div class="text">
                                    100%
                                </div>
                            </div>
                            <div class="score" :style="`left:calc(${practiceProgressPercent}% - 1.5rem)`">
                                {{practiceProgressPercent}}%
                                <i class="el-icon-caret-bottom icon"></i>
                            </div>
                        </div>
                    </div>     
                </div>
                <div class="mainStep" v-for="(mainItem,key) in practiceDetailData" :key="mainItem.name">
                    <div class="mainTitle">
                        <h2>{{ key+1 }}.{{ mainItem.name }}&nbsp;({{ key+1+"/"+practiceDetailData.length }})</h2>
                        <h3 v-if="mainItem.description != ''">{{ mainItem.description }}</h3>
                    </div>
                    <div class="item" v-for="(item,itemKey) in mainItem.child" :key="itemKey+'_'+item.name">
                        <div class="row">
                            <div class="title">
                                <div class="left">
                                    <h3 v-if="!$root.isMob()">步骤({{ itemKey+1 + "/" + mainItem.child.length }}):</h3>
                                    <h4 v-if="$root.isMob()">步骤({{ itemKey+1 + "/" + mainItem.child.length }}):</h4>
                                </div>
                                <h3 v-if="item.finish_status == 2 && !$root.isMob()" class="right">{{ item.name }}</h3>
                                <h3 v-if="item.finish_status == 1 && !$root.isMob()" class="skip">{{ item.name }}</h3>

                                <h4 v-if="item.finish_status == 2 && $root.isMob()" class="right">{{ item.name }}</h4>
                                <h4 v-if="item.finish_status == 1 && $root.isMob()" class="skip">{{ item.name }}</h4>
                            </div>
                            <div class="isRight" v-if="!$root.isMob()">
                                <div class="text" v-if="item.finish_status == 2">
                                    <el-tag type="success">已完成</el-tag>
                                </div>
                                <div class="text" v-if="item.finish_status == 1">
                                    <el-tag type="info">未完成</el-tag>
                                </div>
                            </div>
                        </div>

                        <div class="isRight" v-if="$root.isMob()">
                            <div class="text" v-if="item.finish_status == 2">
                                <h4>状态:</h4><el-tag type="success">已完成</el-tag>
                            </div>
                            <div class="text" v-if="item.finish_status == 1">
                                <h4>状态:</h4><el-tag type="info">未完成</el-tag>
                            </div>
                        </div>

                        <div class="row description" v-if="item.step_description && item.step_description !== ''">
                            <div class="left">
                                <h4>步骤说明:</h4>
                            </div>
                            <div class="text">
                                {{ item.step_description }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="logDetail" :class="$root.isMob()?'detailMobT2':''" v-loading="detailLoading" v-if="type == 2 || type == 3">
                <div :class="isShowHelp ? 'helpButton op' : 'helpButton'" @click="isShowHelp = !isShowHelp">
                    帮助
                    <i class="el-icon-caret-top icon"></i>                    
                </div>
                <div :class="isShowHelp ? 'explain show' : 'explain'">
                    <div class="left">
                        <h2>
                            选项说明:
                        </h2>
                        <h2><el-tag type="success">绿色选项</el-tag>&nbsp;表示正确答案</h2>
                        <!-- <h2><el-tag type="danger">红色选项</el-tag>&nbsp;表示您选择的内容但并非正确答案</h2> -->
                        <h2><div class="normal">无色选项</div>&nbsp;表示错误答案</h2>
                    </div>     
                    <div class="right">
                        <h2>
                            结果说明:
                        </h2>
                        <h2 class="isRight">绿色标题表示回答正确或部分得分</h2>
                        <!-- <h2 class="isRight">问答题中的绿色标题代表正确或部分得分</h2> -->
                        <h2 class="isWrong">红色标题表示回答错误</h2>
                        <!-- <h2 class="isRight2">黄色标题表示回答部分正确</h2> -->
                        <h2 class="isSkip">灰色标题表示未答题</h2>
                    </div>               
                </div>

                <div class="scoreTable">
                    <div class="col">
                        <div class="title">
                            题号
                        </div>
                        <div class="score">
                            得分
                        </div>
                    </div>
                    <div class="col">
                        <div class="title">
                            一
                        </div>
                        <div class="score">
                            <span>{{ score1 }}</span>/{{ score1Total }}
                        </div>
                    </div>
                    <div class="col">
                        <div class="title">
                            二
                        </div>
                        <div class="score">
                            <span>{{ score2 }}</span>/{{ score2Total }}
                        </div>
                    </div>
                    <div class="col">
                        <div class="title">
                            三
                        </div>
                        <div class="score">
                            <span>{{ score3 }}</span>/{{ score3Total }}
                        </div>
                    </div>
                    <div class="col">
                        <div class="title">
                            四
                        </div>
                        <div class="score">
                            <span>{{ score4 }}</span>/{{ score4Total }}
                        </div>
                    </div>
                    <div class="col">
                        <div class="title total">
                            总分
                        </div>
                        <div class="score">
                            <span>{{ detailScoreTotal }}</span>/{{ parseFloat(detailScoreFull).toFixed(1) }}
                        </div>
                    </div>
                </div>
                
                <div class="type">
                    <div class="title"><h2>一、判断题(每题{{score1Every}}分，共{{judgeListsLength}}题，共{{score1Total}}分)</h2></div>
                    <div class="item" v-for="(item,key) in detailData.judge_lists" :key="item.id">
                        <div class="title">
                            <!-- <div class="left">
                                <h3>{{ key+1 }}.题目({{ key+1+"/"+detailData.judge_lists.length }}):</h3>
                            </div>   -->
                            <div class="right">
                                <h3 class="right" v-if="item.status == 2 && item.yn_answer == 2">
                                    {{ key+1 }}. 
                                    {{ item.name }}
                                    <el-tag v-if="!$root.isMob()" type="success">回答正确</el-tag>
                                </h3>
                                <h3 class="wrong" v-if="item.status == 1 && item.yn_answer == 2">
                                    {{ key+1 }}. 
                                    {{ item.name }}
                                    <el-tag v-if="!$root.isMob()" type="danger">回答错误</el-tag>
                                </h3>
                                <h3 class="skip" v-if="item.yn_answer == 1">
                                    {{ key+1 }}. 
                                    {{ item.name }}
                                    <el-tag v-if="!$root.isMob()" type="info">未答题</el-tag>
                                </h3>
                            </div>
                        </div>
                        <div class="imgBox">
                            <div class="img" v-for="(img,index) in item.cover_img" :key="'img_'+item.id+'_'+index">
                                <el-image  style="width: 100%;"
                                    fit="contain"
                                    :src="img" 
                                    :preview-src-list="item.cover_img">
                                </el-image>
                            </div>   
                        </div>                        
                        <div class="options">
                            <div class="left"><h3>选项:</h3></div>
                            <div class="optionItems">
                                <div class="optionItem">
                                    <!-- <div class="normal" v-if="item.answer_result == null || (item.status == 2 && item.answer_result == 2)">正确</div> -->
                                    <el-tag type="success" v-if="item.judge_answer == 1">正确</el-tag>
                                    <div class="normal" v-else>正确</div>
                                    <!-- <el-tag type="danger" v-if="item.yn_answer == 2 && item.status == 1 && item.answer_result == 2">正确</el-tag> -->
                                </div>
                                <div class="optionItem">
                                    <!-- <div class="normal" v-if="item.answer_result == null || (item.status == 2 && item.answer_result == 1)">错误</div> -->
                                    <el-tag type="success" v-if="item.judge_answer == 2">错误</el-tag>
                                    <div class="normal" v-else>错误</div>                                    
                                </div>
                            </div>                        
                        </div>
                        <div class="myAnswer">
                            <div class="left"><h3>我的回答:</h3></div>
                            <div class="right">
                                <div class="text">
                                    <span v-if="item.answer_result == 1">
                                        正确
                                        <i v-if="item.status == 2" class="el-icon-circle-check icon isRight"></i>
                                        <i v-if="item.status == 1" class="el-icon-circle-close icon isWrong"></i>
                                    </span>
                                    <span v-if="item.answer_result == 2">
                                        错误
                                        <i v-if="item.status == 2" class="el-icon-circle-check icon isRight"></i>
                                        <i v-if="item.status == 1" class="el-icon-circle-close icon isWrong"></i>
                                    </span>
                                    <span v-if="item.answer_result == ''"></span>
                                </div>
                            </div>
                        </div>
                        <div class="score">
                            <div class="left"><h3>得分:</h3></div>
                            <div class="right num"><span>{{ parseFloat(item.score_result).toFixed(0) }}</span>/{{ item.score }}分</div>
                            <!-- <i class="el-icon-circle-check icon right" v-if="item.status == 2 && item.yn_answer == 2"></i>
                            <i class="el-icon-circle-close icon wrong" v-if="item.status == 1 && item.yn_answer == 2"></i>
                            <i class="el-icon-remove-outline icon skip" v-if="item.yn_answer == 1"></i> -->
                        </div>
                        <div class="analysis">
                            <div class="left"><h3>标准答案:</h3></div>
                            <div class="right" v-html="item.analysis"></div>
                        </div>
                    </div>
                </div>

                <div class="type">
                    <div class="title"><h2>二、选择题(每题{{score2Every}}分，共{{selectListsLength}}题，共{{score2Total}}分)</h2></div>
                    <div class="item" v-for="(item,key) in detailData.select_lists" :key="item.id">
                        <div class="title">
                            <!-- <div class="left">
                                <h3>{{ key+1 }}.</h3>
                            </div>   -->
                            <div class="right">
                                <h3 class="right" v-if="item.status == 2 && item.yn_answer == 2">
                                    {{ key+1 }}.
                                    {{ item.name }}
                                    <el-tag v-if="!$root.isMob()" type="success">回答正确</el-tag>
                                </h3>
                                <h3 class="wrong" v-if="item.status == 1 && item.yn_answer == 2">
                                    {{ key+1 }}.
                                    {{ item.name }}
                                    <el-tag v-if="!$root.isMob()" type="danger">回答错误</el-tag>
                                </h3>
                                <h3 class="skip" v-if="item.yn_answer == 1">
                                    {{ key+1 }}.
                                    {{ item.name }}
                                    <el-tag v-if="!$root.isMob()" type="info">未答题</el-tag>
                                </h3>
                            </div>
                        </div>
                        <div class="imgBox">
                            <div class="img" v-for="(img,index) in item.cover_img" :key="'img_'+item.id+'_'+index">
                                <el-image  style="width: 100%;"
                                    fit="contain"
                                    :src="img" 
                                    :preview-src-list="item.cover_img">
                                </el-image>
                            </div>   
                        </div>                        
                        <div class="options">
                            <div class="left"><h3>选项:</h3></div>
                            <div class="optionItems">
                                <div class="optionItem" v-for="o in item.options_text" :key="o.option_title">
                                    <el-tag v-if="o.yn_right == 2" type="success">{{ o.option_key }}.{{ o.option_title }}</el-tag>
                                    <div class="normal" v-else>{{ o.option_key }}.{{ o.option_title }}</div>
                                </div>
                            </div>                        
                        </div>
                        <div class="myAnswer">
                            <div class="left"><h3>我的回答:</h3></div>
                            <div class="right">
                                <div class="text">
                                    <span v-if="item.answer_result != ''">
                                        {{ item.answer_result }}
                                        <i v-if="item.status == 2 && item.yn_answer == 2" class="el-icon-circle-check icon isRight"></i>
                                        <i v-if="item.status == 1 && item.yn_answer == 2" class="el-icon-circle-close icon isWrong"></i>
                                    </span>
                                    <span v-else></span>
                                </div>
                            </div>
                        </div>
                        <div class="score">
                            <div class="left"><h3>得分:</h3></div>
                            <div class="right num"><span>{{ parseFloat(item.score_result).toFixed(0) }}</span>/{{ item.score }}分</div>
                            <!-- <i class="el-icon-circle-check icon right" v-if="item.status == 2 && item.yn_answer == 2"></i>
                            <i class="el-icon-circle-close icon wrong" v-if="item.status == 1 && item.yn_answer == 2"></i>
                            <i class="el-icon-remove-outline icon skip" v-if="item.yn_answer == 1"></i> -->
                        </div>
                        <div class="analysis">
                            <div class="left"><h3>标准答案:</h3></div>
                            <div class="right" v-html="item.analysis"></div>
                        </div>
                    </div>
                </div>

                <div class="type">
                    <div class="title"><h2>三、填空题(每题{{score3Every}}分，共{{blankListsLength}}题，共{{score3Total}}分)</h2></div>
                    <div class="item" v-for="(item,key) in detailData.blank_lists" :key="item.id">
                        <div class="title">
                            <!-- <div class="left">
                                <h3>{{ key+1 }}.题目({{ key+1+"/"+detailData.blank_lists.length }}):</h3>
                            </div>   -->
                            <div class="right">
                                <h3 class="right" v-if="item.status == 2 && item.yn_answer == 2" v-html="blankFormat(item,key)"></h3>
                                <h3 class="halfRight" v-if="item.status == 3 && item.yn_answer == 2" v-html="blankFormat(item,key)"></h3>
                                <h3 class="wrong" v-if="item.status == 1 && item.yn_answer == 2" v-html="blankFormat(item,key)"></h3>
                                <h3 class="skip" v-if="item.status == 5 && item.yn_answer == 2" v-html="blankFormat(item,key)"></h3>
                                <h3 class="skip" v-if="item.yn_answer == 1" v-html="blankFormat(item,key)"></h3>
                            </div>
                        </div>
                        <div class="imgBox">
                            <div class="img" v-for="(img,index) in item.cover_img" :key="'img_'+item.id+'_'+index">
                                <el-image  style="width: 100%;"
                                    fit="contain"
                                    :src="img" 
                                    :preview-src-list="item.cover_img">
                                </el-image>
                            </div>   
                        </div>
                        <div class="score blankScore">
                            <div class="left"><h3>得分:</h3></div>
                            <div class="right num" v-if="item.status != 5">
                                <span>{{ item.score_result }}</span>/{{ parseFloat(item.score).toFixed(1) }}分
                            </div>
                            <div class="right num noScore" v-if="item.status == 5">
                                尚未评分
                            </div>
                            <!-- <i class="el-icon-circle-check icon right" v-if="item.status == 2 && item.yn_answer == 2"></i>
                            <i class="el-icon-circle-check icon halfRight" v-if="item.status == 3 && item.yn_answer == 2"></i>
                            <i class="el-icon-circle-close icon wrong" v-if="item.status == 1 && item.yn_answer == 2"></i>
                            <i class="el-icon-remove-outline icon skip" v-if="item.yn_answer == 1"></i> -->
                        </div>
                        <div class="analysis">
                            <div class="left"><h3>标准答案:</h3></div>
                            <div class="right" v-html="item.analysis"></div>
                        </div>
                    </div>
                </div>

                <div class="type">
                    <div class="title"><h2>四、问答题(每题{{score4Every}}分，共{{questionListsLength}}题，共{{score4Total}}分)</h2></div>
                    <div class="item" v-for="(item,key) in detailData.question_lists" :key="item.id">
                        <div class="title">
                            <!-- <div class="left">
                                <h3>{{ key+1 }}.题目({{ key+1+"/"+detailData.question_lists.length }}):</h3>
                            </div>   -->
                            <div class="right">
                                <h3 class="halfRight" v-if="item.status == 3 && item.yn_answer == 2">
                                    {{ key+1 }}. 
                                    {{ item.name }}
                                    <!-- <el-tag type="warning">部分正确</el-tag> -->
                                    <el-tag v-if="!$root.isMob()" type="success">部分正确</el-tag>
                                </h3>
                                <h3 class="right" v-if="item.status == 2 && item.yn_answer == 2">
                                    {{ key+1 }}. 
                                    {{ item.name }}
                                    <el-tag v-if="!$root.isMob()" type="success">回答正确</el-tag>
                                </h3>
                                <h3 class="wrong" v-if="item.status == 1 && item.yn_answer == 2">
                                    {{ key+1 }}. 
                                    {{ item.name }}
                                    <el-tag v-if="!$root.isMob()" type="danger">回答错误</el-tag>
                                </h3>
                                <h3 class="skip" v-if="item.status == 5 && (item.yn_answer == 2 || item.yn_answer == 1)">
                                    {{ key+1 }}. 
                                    {{ item.name }}
                                    <el-tag v-if="!$root.isMob()" type="info">尚未评分</el-tag>
                                </h3>
                                <h3 class="skip" v-if="item.yn_answer == 1 && item.status != 5">
                                    {{ key+1 }}. 
                                    {{ item.name }}
                                    <el-tag v-if="!$root.isMob()" type="info">未答题</el-tag>
                                </h3>
                            </div>
                        </div>
                        <div class="imgBox">
                            <div class="img" v-for="(img,index) in item.cover_img" :key="'img_'+item.id+'_'+index">
                                <el-image  style="width: 100%;"
                                    fit="contain"
                                    :src="img" 
                                    :preview-src-list="item.cover_img">
                                </el-image>
                            </div>   
                        </div>
                        <div class="score questionScore">
                            <div class="left"><h3>得分:</h3></div>
                            <div class="right num" v-if="item.status != 5">
                                <span>{{ item.score_result }}</span>/{{ parseFloat(item.score).toFixed(1) }}分
                            </div>
                            <div class="right num noScore" v-if="item.status == 5">
                                尚未评分
                            </div>
                            <!-- <i class="el-icon-circle-check icon halfRight" v-if="item.status == 3 && item.yn_answer == 2"></i>
                            <i class="el-icon-circle-check icon right" v-if="item.status == 2 && item.yn_answer == 2"></i>
                            <i class="el-icon-circle-close icon wrong" v-if="item.status == 1 && item.yn_answer == 2"></i>
                            <i class="el-icon-remove-outline icon skip" v-if="item.yn_answer == 1"></i> -->
                        </div>
                        <div class="analysis">
                            <div class="left"><h3>答:</h3></div>
                            <div class="right">
                                {{ item.answer_result }}
                            </div>                            
                        </div>
                        <div class="analysis">
                            <div class="left"><h3>标准答案:</h3></div>
                            <div class="right" v-html="item.analysis"></div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
  name: 'logList',
  props:{
    type:{        
        type:Number,
        default:1
    },
    title:{
        type:String,
        default:''
    },
    logId:{
        type:Number,
        default:0
    }
  },
  watch:{
    "type"(){
        // 重置所有相关状态
        this.currentPage = 1;
        this.logsList = [];
        this.labelName = "项目名称";
        this.loading = false;
        this.detailLoading = false;
        this.isShowDetail = false;
        
        // 清除定时器
        if(this.timer){
            clearInterval(this.timer);
            this.timer = null;
        }
        
        // 重新获取数据
        this.getData(this.currentPage);
    },
    "currentPage"(){
        //id=0,page=1,limit=3,keyword=""
        this.getData(this.currentPage)
    },
  },
  data(){
    return {
        API:window.config.api,
        logsList:[
            {
                "name":"项目名称",
                "start":"2023-05-01",
                "end":"2023-05-05",
                "score":"100"
            },
        ],
        detailData:[],
        detailTitle:"答卷详情",
        unityDetailData:[],
        mainSteps:[],
        detailScoreTotal:"",
        detailScoreFull:"",
        pageNum:5,
        currentPage:1,
        isShowDetail:false,
        loading:false,
        detailLoading:false,
        isShowHelp:false,        
        labelName:"项目名称",
        assessment:"",
        score1:0,
        score2:0,
        score3:0,
        score4:0,
        score1Total:0,
        score2Total:0,
        score3Total:0,
        score4Total:0,
        score1Every:0,
        score2Every:0,
        score3Every:0,
        score4Every:0,
        examineDimension:[],
        examineDimensionMax:0,
        examineScores:0,
        selectListsLength:0,
        judgeListsLength:0,
        blankListsLength:0,
        questionListsLength:0,
        timer:null,
        practiceDetailData:[],
        practiceFinishedSteps:0,
        practiceTotalSteps:0,
        practiceProgressPercent:0,
    }
  },
  methods: {
    async getData(page,useLoading=true){
        if(useLoading){
            this.loading = true;
        }
        
        //实操考核记录
        if(this.type == 1){
            this.labelName = "项目名称";
            let data = await this.$root.getUnityLog(0,page);
            if(data){
                data.data.forEach(item => {
                    if(item.endtime){
                        //将item.endtime转字符串
                        let endtime = item.endtime.toString();
                        let starttime = item.starttime.toString();
                        endtime = endtime.length == 10 ? endtime : endtime.substring(0,10);
                        starttime = starttime.length == 10 ? starttime : starttime.substring(0,10);
                        item.usetime = (endtime - starttime);
                        if(item.usetime > 60){
                            item.usetime = parseInt(item.usetime/60) + "分" + (item.usetime%60) + "秒";
                        }
                        else{
                            item.usetime = item.usetime + "秒";
                        }
                        //item.usetime = item.usetime > 60 ? (item.usetime/60).toFixed(2) + "分钟" : item.usetime + "秒";
                        item.endtime = this.$root.formatDate(item.endtime);
                    }
                    else{
                        item.usetime = "/";
                        item.endtime = "/";
                    }
                    item.starttime = this.$root.formatDate(item.starttime);
                    if(item.exam_result == "0"){
                        item.exam_result = "未完成";
                    }

                    item.name = item.dj_name;
                });
                this.logsList = data.data
                this.pageNum = data.last_page
            }        
        }

        //理论考核记录
        if(this.type == 2){
            this.labelName = "试卷名称";
            let data = await this.$root.getTestsLog(0,page);
            if(data){
                data.data.forEach(item => {
                    item.createtime = this.$root.formatDate(item.createtime);
                    item.status = item.yn_score;
                    if(item.yn_score == 1){
                        item.status_text = '尚未评分';
                    }
                    if(item.yn_score == 2){
                        item.status_text = '已评分';
                    }
                });
                this.logsList = data.data
                this.pageNum = data.last_page
            }
        }

        if(this.type == 3){
            this.labelName = "试卷名称";
            let data = await this.$root.getPracticeLog(page);
            if(data){
                data.data.forEach(item => {
                    item.usetime = (item.endtime - item.createtime);
                    if(item.usetime > 60){
                        item.usetime = parseInt(item.usetime/60) + "分" + (item.usetime%60) + "秒";
                    }
                    else{
                        item.usetime = item.usetime + "秒";
                    }
                    item.createtime = this.$root.formatDate(item.createtime);
                    item.endtime = this.$root.formatDate(item.endtime);                   
                });
                this.logsList = data.data
                this.pageNum = data.last_page
            }
        }
        if(this.type == 6){
            this.labelName = "项目名称";
            let data = await this.$root.getUnityTestLog(page);
            if(data){
                data.data.forEach(item => {
                    // 项目名称
                    item.name = item.dj_name;
                    // 完成步骤（如 2/33）
                    const totalSteps = parseInt(item.steps_little_nums) || 0;
                    const finishedSteps = parseInt(item.steps_finish_nums) || 0;
                    item.step = `${finishedSteps}/${totalSteps}`;
                    // 完成进度（百分比）
                    let percent = 0;
                    if(totalSteps > 0){
                        percent = Math.round((finishedSteps / totalSteps) * 100);
                    }
                    item.progress = percent + "%";
                    // 计算耗时
                    if(item.endtime && item.starttime){
                        let endtime = item.endtime.toString();
                        let starttime = item.starttime.toString();
                        endtime = endtime.length == 10 ? endtime : endtime.substring(0,10);
                        starttime = starttime.length == 10 ? starttime : starttime.substring(0,10);
                        item.usetime = (endtime - starttime);
                        if(item.usetime > 60){
                            item.usetime = parseInt(item.usetime/60) + "分" + (item.usetime%60) + "秒";
                        }
                        else{
                            item.usetime = item.usetime + "秒";
                        }
                    }
                    else{
                        item.usetime = "/";
                    }
                    // 开始/结束时间格式化（参考考核记录）
                    if(item.endtime){
                        item.endtime = this.$root.formatDate(item.endtime);
                    }
                    else{
                        item.endtime = "/";
                    }
                    item.starttime = this.$root.formatDate(item.starttime);
                });
                this.logsList = data.data
                this.pageNum = data.last_page
            }
        }
        if(useLoading){
            this.$root.goTop();
            this.loading = false;
        } 
    },
    async view(row){
        this.detailLoading = true;
        if(this.type == 2 || this.type == 3){
            //初始化
            this.score1 = 0;
            this.score2 = 0;
            this.score3 = 0;
            this.score4 = 0;
            this.score1Total = 0;
            this.score2Total = 0;
            this.score3Total = 0;
            this.score4Total = 0;


            this.isShowDetail = true;
            let data = null;
            if(this.type == 2){
                data = await this.$root.getTestsPaperAnswer(row.id);
            }
            if(this.type == 3){
                data = await this.$root.getPracticeAnswer(row.id);
            }
            if(this.type == 2){
                this.detailTitle = "答卷详情 - " + data.exam_info.name;
                this.detailScoreTotal = data.exam_info.exam_scores;
                this.detailScoreFull = data.exam_info.tests_scores;
            }
            if(this.type == 3){
                this.detailScoreTotal = data.practice_info.exam_scores;
                this.detailScoreFull = data.practice_info.tests_scores;
            }
            
            this.detailData = data;
            this.selectListsLength = data.select_lists.length;
            this.judgeListsLength = data.judge_lists.length;
            this.blankListsLength = data.blank_lists.length;
            this.questionListsLength = data.question_lists.length;
            

            //统计判断题总分及得分情况
            data.judge_lists.forEach(item => {
                this.score1Total = parseFloat(this.score1Total) + parseFloat(item.score);
                this.score1 = parseFloat(this.score1) + parseFloat(item.score_result);
                this.score1 = this.score1.toFixed(0);
                this.score1Total = this.score1Total.toFixed(0);
                this.score1Every = item.score;
                item.cover_img.forEach((element,key) => {
                    item.cover_img[key] = this.API + element;
                });
            });
            //统计选择题总分及得分情况
            data.select_lists.forEach(item => {
                this.score2Total = parseFloat(this.score2Total) + parseFloat(item.score);
                this.score2 = parseFloat(this.score2) + parseFloat(item.score_result);
                this.score2 = this.score2.toFixed(0);
                this.score2Total = this.score2Total.toFixed(0);
                this.score2Every = item.score;
                item.cover_img.forEach((element,key) => {
                    item.cover_img[key] = this.API + element;
                });
            });
            //统计填空题总分及得分情况
            data.blank_lists.forEach(item => {
                this.score3Total = parseFloat(this.score3Total) + parseFloat(item.score);
                this.score3 = parseFloat(this.score3) + parseFloat(item.score_result);
                this.score3 = this.score3.toFixed(1);
                this.score3Total = this.score3Total.toFixed(1);
                this.score3Every = item.score.toFixed(1);
                item.cover_img.forEach((element,key) => {
                    item.cover_img[key] = this.API + element;
                });
            });
            //统计问答题总分及得分情况
            data.question_lists.forEach(item => {
                this.score4Total = parseFloat(this.score4Total) + parseFloat(item.score);
                this.score4 = parseFloat(this.score4) + parseFloat(item.score_result);
                this.score4 = this.score4.toFixed(1);
                this.score4Total = this.score4Total.toFixed(1);
                this.score4Every = item.score.toFixed(1);
                item.cover_img.forEach((element,key) => {
                    item.cover_img[key] = this.API + element;
                });
            });
        }
        if(this.type == 1){
            if(row.steps != null && row.steps != ''){
                this.detailTitle = "考核详情 - "+ row.dj_name;
                this.isShowDetail = true;
                let json = JSON.parse(row.steps);
                console.log(json);
                json.exam_result = row.exam_result;
                this.unityDetailData = json;
                // console.log(this.unityDetailData);

                //统计关键步骤
                this.mainSteps = [];
                json.forEach(item => {                    
                    item.child.forEach(element => {
                        if(element.yn_main == 2){
                            this.mainSteps.push({
                                "name":element.name,
                                "status":element.yn_right,
                            });
                        }
                    });
                });
                this.mainSteps.forEach(item => {                    
                    if(item.status == 1){
                        item.status = "error";
                    }
                    if(item.status == 3){
                        item.status = "success";
                    }
                    if(item.status == 4){
                        item.status = "wait";
                    }
                });

                
                this.examineScores = row.exam_scores;
                let data = await this.$root.getDjData(row.dj_id);
                let examineDimension = data.data.examine_dimension_text;
                this.assessment = data.data.assessment;
                //将examineDimension按score字段排序
                examineDimension.sort((a,b) => {
                    return a.score - b.score;
                });
                this.examineDimension = examineDimension;
                let examineDimensionMax = 0;
                examineDimension.forEach(item => {
                    let score = parseFloat(item.score);
                    if(examineDimensionMax < score){
                        examineDimensionMax = item.score;
                    }
                });
                examineDimension.forEach((item,index) => {
                    if(index == 0){
                        item.width = (item.score / examineDimensionMax) * 100;
                    }
                    else{
                        item.width = ((item.score / examineDimensionMax) * 100) - (examineDimension[index-1].score / examineDimensionMax) * 100;
                    }
                });
                this.examineDimensionMax = examineDimensionMax;
            }
            else{
                this.$alert('暂未同步记录 请稍后查看!', '通知',{confirmButtonText: '好的'});
            }
        }
        if(this.type == 6){
            if(row.steps != null && row.steps != ''){
                this.detailTitle = "练习详情 - "+ row.dj_name;
                let json = JSON.parse(row.steps);
                this.practiceDetailData = json;

                // 计算总步骤数和完成步骤数
                let totalSteps = 0;
                let finishedSteps = 0;
                json.forEach(mainItem => {
                    mainItem.child.forEach(child => {
                        totalSteps++;
                        if (child.finish_status === 2) {
                            finishedSteps++;
                        }
                    });
                });
                this.practiceTotalSteps = totalSteps;
                this.practiceFinishedSteps = finishedSteps;
                this.practiceProgressPercent = totalSteps > 0 ? Math.round((finishedSteps / totalSteps) * 100) : 0;

                this.isShowDetail = true;
            }
            else{
                this.$alert('暂未同步记录 请稍后查看!', '通知',{confirmButtonText: '好的'});
            }            
        }
        
        this.detailLoading = false;
    },
    changePage(page){
        this.currentPage = page;
    },
    blankFormat(item,key){
        // <el-tag type="success" v-if="item.status == 2 && item.yn_answer == 2">回答正确</el-tag>
        // <el-tag type="warning" v-if="item.status == 3 && item.yn_answer == 2">部分正确</el-tag>
        // <el-tag type="danger" v-if="item.status == 1 && item.yn_answer == 2">回答错误</el-tag>
        // <el-tag type="info" v-if="item.yn_answer == 1">未答题</el-tag>
        // <el-tag type="info" v-if="item.status == 5 && item.yn_answer == 2">尚未评分</el-tag>

        let name = item.name;
        let className = "";
        let elTag = `<span class="el-tag el-tag--info el-tag--light">未答题</span>`;


        if(item.status == 2 && item.yn_answer == 2){
            className = "answer-right";
            elTag = `<span class="el-tag el-tag--success el-tag--light">回答正确</span>`;
        }
        if(item.status == 1 && item.yn_answer == 2){
            className = "answer-wrong";          
            elTag = `<span class="el-tag el-tag--danger el-tag--light">回答错误</span>`;
        }
        if(item.status == 3 && item.yn_answer == 2){
            className = "answer-halfRight";
            elTag = `<span class="el-tag el-tag--success el-tag--light">部分正确</span>`;
        }
        if(item.yn_answer == 1){
            className = "answer-empty";
        }
        if(item.status == 5 && item.yn_answer == 2){
            className = "answer-empty";
            elTag = `<span class="el-tag el-tag--info el-tag--light">尚未评分</span>`;
        }
        
        item.answer_result_text.forEach(text => {
            let length = 0;
            if(text.length < 6){
                length = 6;
            }
            else{
                length = text.length + 2;
            }
            name = name.replace("______",`<input class='answer ${className}'
            style='margin: 0 10px;
            border: 0;
            border-bottom: 1px solid;
            outline: none;
            text-align: center;
            background-color: transparent;
            width:${length}em' readonly value='${text}'>
            </input>`);
        });

        if(item.answer_result_text.length == 0){
            name = name.replace(/______+/g, `<input class='answer ${className}' 
            style='margin: 0 10px; 
            border: 0; 
            border-bottom: 1px solid; 
            outline: none; 
            text-align: center;
            background-color: transparent;
            width:6em' value='' readonly>
            </input>`);
        }
        if(this.$root.isMob()){
            return "<div class='blankAnswer'>"+(key+1)+". "+name+"</div>";
        }
        else{
            return "<div class='blankAnswer'>"+(key+1)+". "+name+elTag+"</div>";
        }
    },
    async viewOfId(id){
        let data = await this.$root.getUnityExamInfo(id);
        if(data){
            this.view(data)
        }
    }
  },
created() {
    // 根据 type 初始化 labelName
    if(this.type == 1 || this.type == 6) {
        this.labelName = "项目名称";
    } else if(this.type == 2) {
        this.labelName = "试卷名称";
    }
    
    this.getData();
    if(this.logId){
        this.viewOfId(this.logId);
        this.$emit("isViewing",true);
    }
},
updated() {
    if(this.type == 1 && !this.timer){
        this.timer = setInterval(() => {
            this.getData(this.currentPage,false);
        }, 1000);
    }
    if(this.type != 1 && this.timer){
        clearInterval(this.timer); 
        this.timer = null;
    }
},
destroyed(){
    if(this.timer){
        clearInterval(this.timer); 
        this.timer = null;
    }    
}
}
</script>

<style scoped lang="scss" src="@/assets/css/lib/logList.scss"></style>